import React from 'react';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const DetailItem = ({ label, className, children }) => {
	const labels = useLabels();
	return (
		<li className={className} data-testid="detail-item">
			<span className="details-label font-weight-bold">
				{labels.get(label)}:
			</span>{' '}
			{children}
		</li>
	);
};

export default DetailItem;

const DetailItemProp = {
	label: propTypes.string.isRequired,
	className: propTypes.string,
	children: propTypes.node.isRequired
};

DetailItem.propTypes = DetailItemProp;
